<template>
  <div>
    <div v-if="this.source == 1">
      <span style="display: flex !important; color: #0d6efd; font-size: 15px">Pay Monthly</span>
    </div>
    <div id="up-pay-monthly-selector-from-pricing" v-if="this.source == 1 || this.source == 2" style="
        display: flex !important;
        flex-wrap: wrap !important;
        color: #0d6efd;
      ">
      <div style="cursor: pointer; font-size: 12px" :data-up-price-value="this.totalAmount" data-up-price-type="total">
        <div style="display: flex !important; flex-wrap: wrap !important;justify-content: center;">
          <span class="me-1" style="color: grey; font-size: 12px"> from </span>
          <div style="display: flex">
            <span style="font-size: 12px">
              {{ this.paymentUplift?.currency }}</span>
            <span data-up-from-currency-unit-major="" style="font-size: 12px"></span>
            <span style="font-size: 12px; color: grey"> /mo</span>
          </div>
          <span data-up-tooltip="" style="font-size: 12px; color: grey">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em"
              width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z">
              </path>
            </svg>
          </span>
        </div>
      </div>
      <div>
        <div id="#up-pay-monthly-container" src=""></div>
      </div>
    </div>
  </div>
  <span id="up-offer-not-available" data-up-error="" style="display: none">
    Unavailable
    <span data-up-tooltip="" style="font-size: 12px; color: grey">
      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z">
        </path>
      </svg>
    </span>
  </span>
  <div id="up-pay-monthly-selector" src=""></div>
  <div v-if="this.source == 3">
    <div id="up-pay-monthly-container" src="" style="display: block"></div>
  </div>
</template>

<script>
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
import moment from "moment";
import debounce from "lodash/debounce";
export default {
  props: {
    billing_details: {
      type: Object,
      required: true,
    },
    paymentUplift: {
      type: String,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
    bookNowTriggered: {
      type: Boolean,
      default: false,
    },
    bookingtriger: {
      type: Boolean,
      default: false,
    },
    blurInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      totalAmount: "",
      pointScale: "",
      upliftScriptReady: "",

      // orderId:"",
      upliftConfig: {
        uplift_enabled: false,
        up_code: "",
        uplift_url: "",
      },
      tokenAlreadyProcessed: false,
      tokenAvailableProcessed: false,
      upliftInitialized: false,
      billingPreviouslyComplete: false,
      lastValidFields:null,
    };
  },
  methods: {
    getConfig() {
      const getConfigData1 = getConfigDataFromLocalStorage();
      if (getConfigData1) {
        this.pointScale =
          getConfigData1.payload.portal_configuration.currency.iso_code;
        this.upliftConfig = {
          uplift_enabled:
            getConfigData1.payload.portal_configuration.uplift_payment.uplift_enabled || false,
          up_code: 
          // "UP-48608936-99",
          // "UP-86844661-1",
            getConfigData1.payload.portal_configuration.uplift_payment.up_code || "",
          uplift_url:
            getConfigData1.payload.portal_configuration.uplift_payment.uplift_url || "",
        };
      }
    },

    loadUpliftScript() {
      if (!this.upliftConfig.uplift_enabled) {
        console.warn("Uplift is disabled in config");
        this.$emit("uplift-script-loaded", false);
        return;
      }

      const script = document.createElement("script");
      script.src = `${this.upliftConfig.uplift_url}?upcode=${this.upliftConfig.up_code}`;

      script.onload = () => {
        this.upliftReady();

        // let elapsed = 0;
        // const interval = 500;
        // const maxWait = 15000; // wait for 15 seconds max

        // const checkInterval = setInterval(() => {
        //   const amountSpan = document.querySelector('[data-up-from-currency-unit-major]');
        //   if (amountSpan && amountSpan.textContent.trim()) {
        //     clearInterval(checkInterval);
        //     this.$emit("uplift-script-loaded", true);
        //   } else {
        //     elapsed += interval;
        //     if (elapsed >= maxWait) {
        //       clearInterval(checkInterval);
        //       console.warn("Uplift amount not shown in UI after timeout");
        //       this.$emit("uplift-script-loaded", false);
        //       // Optionally, show user-facing fallback UI here
        //     }
        //   }
        // }, interval);
        this.$emit("uplift-script-loaded", true);
      };

      script.onerror = () => {
        this.$emit("uplift-script-loaded", false);
        console.error("Failed to load Uplift script");
      };

      document.head.appendChild(script);
    },

    showUpliftError(errorMsg, errorType) {
      console.log(`Uplift Error [${errorType}]: ${errorMsg}`);
      if (
        window.Uplift &&
        window.Uplift.Payments &&
        typeof window.Uplift.Payments.error === "function"
      ) {
        window.Uplift.Payments.error(errorMsg, errorType);
      }
    },

    upliftReady() {
      window.upReady = () => {
        try {
          if (!this.upliftInitialized) {
            this.initPayMonthly();
            const orderInfo = this.buildOrderInfo();
            window.console.log("The orderInfo object was created: ", orderInfo);
            if (!orderInfo) {
              this.showUpliftError(
                "Order info could not be built",
                "BUILD_ERROR"
              );
              return;
            }
            window.Uplift.Payments.load(orderInfo);
            window.Uplift.Payments.select(orderInfo);
            this.upliftInitialized = true;
          }
        } catch (err) {
          this.showUpliftError(err.message, "INIT_ERROR");
        }
      };
    },

    initPayMonthly() {
      window.Uplift.Payments.init({
        locale: `${this.updatevalue}-${this.paymentUplift?.pointofSale}`,
        currency: this.pointScale,
        checkout: true,
        channel: "desktop",
        container: "#up-pay-monthly-container",
        onChange: this.myOnChangeCallback,
      });
    },

    showUpliftPricing() {
      const pricingElement = document.getElementById("uplift-monthly-offer");
      if (pricingElement) {
        pricingElement.style.display = "inline";
        pricingElement.setAttribute("data-up-price-value", this.orderAmount);
      }
    },

    // confirmUpliftPayment(orderId) {
    //   if (!orderId) {
    //     this.showUpliftError("Missing order ID for confirmation", "booking");
    //     return;
    //   }

    //   try {
    //     if (window.Uplift?.Payments?.confirm) {
    //       window.Uplift.Payments.confirm(orderId);
    //       console.log(orderId, "OrderID");
    //       console.log(`Uplift payment confirmed with order ID: ${orderId}`);
    //     } else {
    //       this.showUpliftError(
    //         "Uplift confirm function is not available",
    //         "fatal"
    //       );
    //     }
    //   } catch (error) {
    //     this.showUpliftError(
    //       `Failed to confirm Uplift payment: ${error.message}`,
    //       "fatal"
    //     );
    //   }
    // },
    multiReq(data) {
      let res = [];

      if (data?.Flight1?.length) {
        res.push({
          departure_apc: data.Flight1[0]?.Departure?.AirportCode,
          arrival_apc:
            data.Flight1[data.Flight1.length - 1]?.Arrival?.AirportCode,
          departure_time: data.Flight1[0]?.Departure?.Date?.replace(/-/g, ""),
          arrival_time: data.Flight1[
            data.Flight1.length - 1
          ]?.Arrival?.Date.replace(/-/g, ""),
          fare_class: data.cabinClass,
          carrier_code: data.Flight1[0]?.MarketingCarrier?.AirlineID,
        });
      }

      if (data?.Flight2?.length) {
        res.push({
          departure_apc: data.Flight2[0]?.Departure?.AirportCode,
          arrival_apc:
            data.Flight2[data.Flight2.length - 1]?.Arrival?.AirportCode,
          departure_time: data.Flight2[0]?.Departure?.Date?.replace(/-/g, ""),
          arrival_time: data.Flight2[
            data.Flight2.length - 1
          ]?.Arrival?.Date.replace(/-/g, ""),
          fare_class: data.cabinClass,
          carrier_code: data.Flight2[0]?.MarketingCarrier?.AirlineID,
        });
      }

      if (data?.Flight3?.length > 0) {
        res.push({
          departure_apc: data.Flight3[0]?.Departure?.AirportCode,
          arrival_apc:
            data.Flight3[data.Flight3.length - 1]?.Arrival?.AirportCode,
          departure_time: data.Flight3[0]?.Departure?.Date?.replace(/-/g, ""),
          arrival_time: data.Flight3[
            data.Flight3.length - 1
          ]?.Arrival?.Date.replace(/-/g, ""),
          fare_class: data.cabinClass,
          carrier_code: data.Flight3[0]?.MarketingCarrier?.AirlineID,
        });
      }
      if (data?.Flight4?.length > 0) {
        res.push({
          departure_apc: data.Flight4[0]?.Departure?.AirportCode,
          arrival_apc:
            data.Flight4[data.Flight4.length - 1]?.Arrival?.AirportCode,
          departure_time: data.Flight4[0]?.Departure?.Date?.replace(/-/g, ""),
          arrival_time: data.Flight4[
            data.Flight4.length - 1
          ]?.Arrival?.Date.replace(/-/g, ""),
          fare_class: data.cabinClass,
          carrier_code: data.Flight4[0]?.MarketingCarrier?.AirlineID,
        });
      }

      // console.log(res, "multicityuplift");
      return res;
    },

    buildOrderInfo() {
      console.log(this.paymentUplift,'paymentUplift')
      const isRoundTrip = this.paymentUplift.triptype.toLowerCase() === "roundtrip";
      const ismulti = this.paymentUplift.triptype.toLowerCase() === "multicity";
      const air_reservations = ismulti
        ? [
          {
            airline_name:
              this.paymentUplift?.Flight1[0]?.MarketingCarrier?.Name,
            origin: this.paymentUplift?.Flight1[0]?.Departure?.AirportCode,
            destination:
              this.paymentUplift?.Flight1[
                this.paymentUplift.Flight1.length - 1
              ]?.Arrival?.AirportCode,
            trip_type: "open_jaw",
            itinerary: this.multiReq(this.paymentUplift),
            insurance: [],
          },
        ]
        : isRoundTrip
          ? [
            {
              airline_name:
                this.paymentUplift?.Depature[0]?.MarketingCarrier?.Name,
              origin: this.paymentUplift?.Depature[0]?.Departure?.AirportCode,
              destination:
                this.paymentUplift?.Depature[
                  this.paymentUplift.Depature.length - 1
                ]?.Arrival?.AirportCode,
              trip_type: this.paymentUplift.triptype.toLowerCase(),
              itinerary: [
                {
                  departure_apc:
                    this.paymentUplift?.Depature[0]?.Departure?.AirportCode,
                  arrival_apc:
                    this.paymentUplift?.Depature[
                      this.paymentUplift.Depature.length - 1
                    ]?.Arrival?.AirportCode,
                  departure_time:
                    this.paymentUplift?.Depature[0]?.Departure?.Date.replace(
                      /-/g,
                      ""
                    ),
                  arrival_time: this.paymentUplift?.Depature[
                    this.paymentUplift.Depature.length - 1
                  ]?.Arrival?.Date.replace(/-/g, ""),
                  fare_class: this.paymentUplift.cabinClass,
                  carrier_code:
                    this.paymentUplift?.Depature[0]?.MarketingCarrier
                      ?.AirlineID,
                },
                {
                  departure_apc: this.paymentUplift?.Return[0]?.Departure?.AirportCode,
                  arrival_apc: this.paymentUplift?.Return[this.paymentUplift.Return.length - 1]?.Arrival?.AirportCode,
                  departure_time: this.paymentUplift?.Return[0]?.Departure?.Date.replace(/-/g, ""),
                  arrival_time: this.paymentUplift?.Return[this.paymentUplift.Depature.length - 1]?.Arrival?.Date.replace(/-/g, ""),
                  fare_class: this.paymentUplift.cabinClass,
                  carrier_code: this.paymentUplift?.Return[0]?.MarketingCarrier?.AirlineID,
                },
              ],
              insurance: [],
            },
          ]
          : [
            {
              airline_name: this.paymentUplift?.Depature[0]?.MarketingCarrier?.Name,
              origin: this.paymentUplift?.Depature[0]?.Departure?.AirportCode,
              destination: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.AirportCode,
              trip_type: this.paymentUplift.triptype.toLowerCase(),
              itinerary: [
                {
                  departure_apc: this.paymentUplift?.Depature[0]?.Departure?.AirportCode,
                  departure_time: this.paymentUplift?.Depature[0]?.Departure?.Date.replace(/-/g, ""),
                  arrival_apc: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.AirportCode,
                  arrival_time: this.paymentUplift?.Depature[this.paymentUplift.Depature.length - 1]?.Arrival?.Date.replace(/-/g, ""),
                  fare_class: this.paymentUplift.cabinClass,
                  carrier_code: this.paymentUplift?.Depature[0]?.MarketingCarrier?.AirlineID,
                },
              ],
              insurance: [],
            },
          ];
      const addOnPrice = parseInt(this.paymentUplift?.add_ons);
      const orderInfo = {
        billing_contact: {
          first_name: this.billing_details?.name?.split(" ")[0].trim() || "",
          last_name: this.billing_details?.name?.split(" ").slice(1).join(" ").trim() || "",
          street_address: this.billing_details?.address1 || "",
          city: this.billing_details?.city || "",
          region: this.billing_details.stateRegion || "",
          country: this.billing_details?.countryRegion || "CA",
          postal_code: this.billing_details?.zipcode || "",
          phone: this.billing_details?.phonenumber || "",
          email: this.billing_details?.email || "",
          date_of_birth: (() => {
            const firstDOB = this.totalpassanger?.[0]?.dateOfBirth;
            const parsedDOB = moment(
              firstDOB,
              [
                "YYYY-MMM-DD",
                "DD-MMM-YYYY",
                "MMM/DD/YYYY",
                "MMM-DD-YYYY",
                moment.ISO_8601,
              ],
              true
            );
            return parsedDOB.isValid() ? parsedDOB.format("MM/DD/YYYY") : "";
          })(),
        },

        travelers: this.travelersDetails,
        air_reservations,
        add_ons:
          !isNaN(addOnPrice) && addOnPrice >= 0
            ? [
              {
                id: 0,
                name: this.paymentUplift?.add_ons_name
                  ? this.paymentUplift.add_ons_name.charAt(0).toUpperCase() +
                  this.paymentUplift.add_ons_name.slice(1)
                  : this.paymentUplift?.add_ons_name,
                price: addOnPrice,
              },
            ]
            : [],
        order_amount: this.totalAmount,
      };
      this.$emit("uplift-order-info-built", orderInfo);
      return orderInfo;
    },
    myOnChangeCallback(response) {
    // console.log(">>>ONCHANGE",response)
      if (!response || !response.status) {
        this.showUpliftError("Invalid response received", "RESPONSE_ERROR");
        return;
      }

      const statusHandlers = {
        OFFER_AVAILABLE: () => {
          // console.log("Offer Available");
          document.getElementById("up-offer-not-available").style.display = "none";
          document.getElementById("up-pay-monthly-selector-from-pricing").style.display = "block";
        },
        TOKEN_AVAILABLE: () => {
          if (this.tokenAvailableProcessed) {
            console.warn("Token available already processed. Skipping.");
            return;
          }
          this.tokenAvailableProcessed = true;
          // const token = window.Uplift.Payments.getToken();
          // console.log("Token:", token);
          this.$emit("uplift-token-received", response);
        },
        TOKEN_RETRIEVED: () => {
          if (this.tokenAlreadyProcessed) {
            console.warn("Token already handled. Skipping.");
            return;
          }
          this.tokenAlreadyProcessed = true;

          const { token } = response;
          if (!token) {
            this.showUpliftError("Missing token in response", "TOKEN_ERROR");
            return;
          }
          console.log("Token Received:",response.token)
          this.$emit("uplift-token-received", response);
        },
        OFFER_UNAVAILABLE: () => {
          document.getElementById("up-offer-not-available").style.display =
            "block";
          document.getElementById(
            "up-pay-monthly-selector-from-pricing"
          ).style.display = "none";
           this.$emit("offer-unavailable", true);
        },
        SERVICE_UNAVAILABLE: () => {
          this.showUpliftError("Service is unavailable", "SERVICE_ERROR");
        },
      };

      statusHandlers[response.status]();
    },

    setupUpReady() {
      if (this.upliftInitialized) {
        console.warn("Uplift already initialized. Skipping setup.");
        return;
      }

      window.upReady = async () => {
        if (this.upliftInitialized) {
          console.warn("Uplift already initialized in upReady. Skipping.");
          return;
        }

        this.initPayMonthly();
        const orderInfo = this.buildOrderInfo();
        if (!orderInfo) {
          this.showUpliftError("Order info could not be built", "BUILD_ERROR");
          return;
        }
        await window.Uplift.Payments.load(orderInfo);
        await window.Uplift.Payments.select(orderInfo);
        this.upliftInitialized = true;
      };
    },
    async getpass() {
      this.travelersDetails = [];
      let passDeatail = [];
      passDeatail = await JSON.parse(sessionStorage.getItem("TravelerDetails"));

      this.totalpassanger = [
        ...passDeatail.adultDatas,
        ...passDeatail.childDatas,
        ...passDeatail.infrantDatas,
      ];
      this.totalpassanger.forEach((a, i) => {
        const parsedDOB = moment(
          a.dateOfBirth,
          [
            "YYYY-MMM-DD",
            "YYYY-MMM-DD",
            "DD-MMM-YYYY",
            "MMM/DD/YYYY",
            "MMM-DD-YYYY",
            moment.ISO_8601,
          ],
          true
        );
        this.travelersDetails.push({
          id: i,
          first_name: a.fname,
          last_name: a.last,
          date_of_birth: parsedDOB.isValid()
            ? parsedDOB.format("MM/DD/YYYY")
            : "",
        });
      });
      // console.log(this.totalpassanger,this.travelersDetails,this.buildOrderInfo(),'passDeatail1111')
    },
    hasBillingDetailsChanged(newVal) {
      const prev = this._prevBillingDetails || {};
      this._prevBillingDetails = { ...newVal }; // Store for next check

      return JSON.stringify(prev) !== JSON.stringify(newVal);
    },
    debouncedLoadUplift: debounce(function () {
      const orderInfo = this.buildOrderInfo();
      if (window.Uplift?.Payments) {
        window.Uplift.Payments.load(orderInfo);
      }
    }, 300),
    getuplift() {
      if (this.upliftInitialized) {
        console.warn("Uplift already initialized. Skipping getuplift.");
        return;
      }

      this.loadUpliftScript();
      const upliftUrl = this.upliftConfig.uplift_url;
      const upliftCode = this.upliftConfig.up_code;
      if (this.upliftConfig.uplift_enabled) {
        this.tokenAlreadyProcessed = false;
        this.tokenAvailableProcessed = false;
        this.upliftInitialized = false;

        (function (u, p, l, i, f, t, o, b, j) {
          u["UpLiftPlatformObject"] = f;
          u[f] =
            u[f] ||
            function () {
              (u[f].q = u[f].q || []).push(arguments);
            };
          u[f].l = 1 * new Date();
          (b = p.createElement(l)), (j = p.getElementsByTagName(l)[0]);
          b.async = 1;
          b.src = i + "?upcode=" + t;
          j.parentNode.insertBefore(b, j);
          o = u.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/);
          if (o) o = o[0];
          u[f]("create", t, o);
        })(window, document, "script", upliftUrl, "up", upliftCode);

        this.setupUpReady();
      }
    },
  },

  created() {
    this.getpass();
    
    // console.log(this.paymentUplift, this.source, "this.paymentUplift11");
    this.totalAmount = parseInt(this.paymentUplift?.TotalPrice * 100);
    this.getConfig();
  },
  computed: {
    updatevalue() {
      return this.$store.getters.getChangedLang;
    },
    isBillingDetailsComplete() {
      const b = this.billing_details || {};
      return (
        !!b.name &&
        !!b.address1 &&
        !!b.city &&
        !!b.state &&
        !!b.country &&
        !!b.zipcode &&
        !!b.phonenumber &&
        !!b.email
      );
    },
  },
  watch: {
    blurInfo(newVal) {
    if (!newVal) return;
    const requiredKeys = ['name', 'address1', 'city', 'state', 'country', 'zipcode', 'phonenumber', 'email'];
    const { allFields } = newVal;
    const allComplete = requiredKeys.every((k) => allFields[k] && allFields[k].toString().trim() !== '');
    if (!allComplete) return;
    const currentSnapshot = {};
    requiredKeys.forEach(k => currentSnapshot[k] = allFields[k].toString().trim());
    const hasChanged =
      !this.lastValidFields ||
      requiredKeys.some(k => this.lastValidFields[k] !== currentSnapshot[k]);
    if (!hasChanged) return;
    this.lastValidFields = { ...currentSnapshot };
    // requiredKeys.forEach((k) => console.log(`${k}: ${allFields[k]}`));
    // console.log(`Load the Last trigger Value in Billing Details➜ ${blurredField}: ${blurredValue}`);
    this.debouncedLoadUplift();
  },

    bookingtriger(newval) {
      if (newval && !this.tokenAlreadyProcessed) {
        window.Uplift.Payments.getToken();
      }
      const orderInfo = this.buildOrderInfo();
      window.Uplift.Analytics.orderSubmit(orderInfo, {
        mode_of_payment: "pay monthly",
        payment_options: ["full", "pay monthly"]
      });
      // console.log("Uplift orderSubmit called");

    },

    updatevalue(newVal) {
      this.upliftScriptReady = newVal;
      if (newVal == "en" || newVal == "fr") {
        this.$emit("uplift-script-loaded", true);
      } else {
        this.$emit("uplift-script-loaded", false);
      }
      this.initPayMonthly();
      const orderInfo = this.buildOrderInfo();
      if (window.Uplift && window.Uplift.Payments) {
        window.Uplift.Payments.load(orderInfo);
        window.Uplift.Payments.select(orderInfo);
      }
    },

    "paymentUplift.add_ons": function (newVal) {
      if (!this.upliftInitialized) return;
      // console.log(oldVal);
      this.totalAmount = parseInt(this.paymentUplift?.TotalPrice * 100) + parseInt(newVal * 100 || 0);
      const orderInfo = this.buildOrderInfo();
      if (!orderInfo) {
        console.error("Failed to rebuild orderInfo.");
        return;
      }

      if (window.Uplift && window.Uplift.Payments) {
        window.Uplift.Payments.load(orderInfo);
        window.Uplift.Payments.select(orderInfo);
      }
    },

    totalAmount: function () {
      if (!this.upliftInitialized) return;
      // console.log(newVal, oldVal);
      const orderInfo = this.buildOrderInfo();

      if (!orderInfo) {
        console.error("Failed to rebuild orderInfo.");
        return;
      }

      if (window.Uplift && window.Uplift.Payments) {
        window.Uplift.Payments.load(orderInfo);
        window.Uplift.Payments.select(orderInfo);
      }
    },
  },
  mounted() {
    this.getuplift();
  },
};
</script>

<style scoped>
:deep(.header-branding) {
  padding: 1em 1.25em;
  background-color: #fff;
  border-bottom: 1px solid #d1d3d7;
  display: contents !important;
}

.header-branding {
  padding: 1em 1.25em;
  background-color: #fff;
  border-bottom: 1px solid #d1d3d7;
  display: contents !important;
}
</style>
